/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable @typescript-eslint/no-object-literal-type-assertion */
import transactionApi from '@resources/scripts/services/api/transaction.api';
import axios from 'axios';
import { APPLY_FOR_LICENSING_FORM } from '../mutation-types';
import { ApplyForLicensingStorePayload } from '../../models/applyForLicensingStorePayload.model';
import licensingApplicationService from '../../services/licensingApplication.service';
import licensingApplicationApi from '../../services/api/applyForLicensing';
import { setState } from '../mutationHelpers';

const namespaced = true;

const getters = {
  countryOptions: storeState => storeState.countryOptions,
  stateProvinceOptions: storeState => countryName => (storeState.countryOptions.find(x => x.name === countryName) ? storeState.countryOptions.find(x => x.name === countryName).stateProvinces : []),
  formFields: storeState => storeState.formFields,
  currentPage: storeState => storeState.currentPage,
  submitting: storeState => storeState.submitting,
  submitted: storeState => storeState.submitted,
};

const state = {
  formFields: {
    pledgeOfEthics: false,
    draftingPolicies: false,
    applicantEligibility: false,

    companyName: '',
    businessType: '',
    companyCountry: '',
    companyAddressLine1: '',
    companyAddressLine2: '',
    companyCompanyCity: '',
    companyCompanyState: '',
    companyCompanyZip: '',
    companyEmail: '',
    companyPhone: '',
    companyFax: '',

    contactPhone: '',
    contactFax: '',
    contactTollFree: '',
    primaryContactFirstName: '',
    primaryContactLastName: '',
    primaryContactTitle: '',
    primaryContactEmail: '',
    companyPrincipalFirstName: '',
    companyPrincipalLastName: '',
    companyPrincipalTitle: '',
    companyPrincipalEmail: '',
    secondCompanyPrincipalFirstName: '',
    secondCompanyPrincipalLastName: '',
    secondCompanyPrincipalTitle: '',
    secondCompanyPrincipalEmail: '',

    conductsWithGeneralPublic: false,
    yearsInBusiness: '',
    numberOfEmployees: '',
    numberOfEmployeesInOffice: '',
    numberInstallers: '',
    totalSquareFootage: '',
    ownLeaseFacility: '',
    ownLeaseEquipment: '',
    annualGrossSales: '',
    lineOfBusiness: [],
    businessSummary: '',

    awiStandards: [],
    hearAboutQpc: '',
    hearAboutQpcOther: '',
    licensingType: '',
    quailityGrade: '',
    licensingSections: [],

    projectOneName: '',
    projectOneCity: '',
    projectOneState: '',
    projectOneValueOfWoodwork: '',
    projectOneYearCompleted: '',
    projectOneProjectSummary: '',
    projectTwoName: '',
    projectTwoCity: '',
    projectTwoState: '',
    projectTwoValueOfWoodwork: '',
    projectTwoYearCompleted: '',
    projectTwoProjectSummary: '',
    projectThreeName: '',
    projectThreeCity: '',
    projectThreeState: '',
    projectThreeValueOfWoodwork: '',
    projectThreeYearCompleted: '',
    projectThreeProjectSummary: '',

    recentlyBidAProjectRequiringQCP: false,
    haveBeenAwardedContractRequiringQCP: false,
    joinReason: '',
    awiStatus: '',

    billingFirstName: '',
    billingLastName: '',
    billingAddressLine1: '',
    billingAddressLine2: '',
    billingCity: '',
    billingState: '',
    billingZip: '',
    billingPhone: '',
    billingEmail: '',

    transactionAmount: 0,
    nameOnCard: '',
    cardNumber: '',
    cardCVV: '',
    cardExpMonth: '',
    cardExpYear: '',
    billingComments: '',
  } as ApplyForLicensingStorePayload,
  currentPage: 1,
  countryOptions: [],
  submitting: false,
  submitted: false,
};

const mutations = {
  [APPLY_FOR_LICENSING_FORM.UPDATE_COUNTRY_OPTIONS]: setState('countryOptions'),
  [APPLY_FOR_LICENSING_FORM.CHANGE_CURRENT_PAGE]: setState('currentPage'),
  [APPLY_FOR_LICENSING_FORM.TOGGLE_SUBMITTED_STATE]: setState('submitted'),
  [APPLY_FOR_LICENSING_FORM.TOGGLE_SUBMITTING_STATE]: setState('submitting'),

  [APPLY_FOR_LICENSING_FORM.FORM_FIELDS](formState, fields) {
    Object.assign(formState.formFields, fields);
  },

  [APPLY_FOR_LICENSING_FORM.UPDATE_PRICE](formState, value) {
    formState.formFields.transactionAmount = value;
  },
};

const actions = {
  goToNextPage({ commit }) {
    commit(APPLY_FOR_LICENSING_FORM.CHANGE_CURRENT_PAGE, state.currentPage + 1);
    window.scrollTo(0, 0);
  },

  goToPrevPage({ commit }) {
    commit(APPLY_FOR_LICENSING_FORM.CHANGE_CURRENT_PAGE, state.currentPage - 1);
    window.scrollTo(0, 0);
  },

  setPrice({ commit }, payload) {
    commit(APPLY_FOR_LICENSING_FORM.UPDATE_PRICE, payload);
  },

  async getCountries({ commit }) {
    const { data } = await axios.get('/api/countries');
    commit(APPLY_FOR_LICENSING_FORM.UPDATE_COUNTRY_OPTIONS, data);
  },

  submitForm({ commit, state: actionState }) {
    return new Promise(async (resolve, reject) => {
      commit(APPLY_FOR_LICENSING_FORM.TOGGLE_SUBMITTING_STATE, true);
      const createPayload = licensingApplicationService.buildCreatePayload(state.formFields);
      try {
        const { data: transactionData } = await transactionApi.addTransaction({
          type: 'APPLY',
          nameOnCard: actionState.formFields.nameOnCard,
          companyName: createPayload.company.name,
          billingAddress1: actionState.formFields.billingAddressLine1,
          billingAddress2: actionState.formFields.billingAddressLine2,
          billingCity: actionState.formFields.billingCity,
          billingStateProvince: actionState.formFields.billingState,
          billingZip: actionState.formFields.billingZip,
          billingEmail: actionState.formFields.billingEmail,
          billingPhone: actionState.formFields.billingPhone,
          cardNumber: actionState.formFields.cardNumber,
          CardExpireMonth: actionState.formFields.cardExpMonth,
          cardExpireYear: actionState.formFields.cardExpYear,
          cVV2: actionState.formFields.cardCVV,
          comments: actionState.formFields.billingComments,
          description: 'New Licensing Application',
          amount: actionState.formFields.transactionAmount,
        });
        const { data: formResult } = await licensingApplicationApi.create(createPayload);
        await licensingApplicationApi.associateTransaction(formResult, transactionData.id);
        commit(APPLY_FOR_LICENSING_FORM.TOGGLE_SUBMITTED_STATE, true);
        try {
          // eslint-disable-next-line @typescript-eslint/no-angle-bracket-type-assertion
          (<any>window).gtag('config', 'UA-69171335-1', {
            page_title: 'Apply for Licensing - Submitted',
            page_path: '/forms/apply-for-licensing/submitted',
          });
        } catch (error) {}
        resolve();
      } catch (error) {
        commit(APPLY_FOR_LICENSING_FORM.TOGGLE_SUBMITTING_STATE, false);
        reject(error);
      }
    });
  },
};

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};